import { useState } from 'react';
import NetProceedsCalc from './NetProceedsCalc';
import TrendChart from './TrendChart';

interface Props {
  predictedPrice: number;
  municipalityCode: string;
  municipalityName: string;
  propertyType: 'condo' | 'house';
}

type Tab = 'net' | 'trend';

const TABS: { id: Tab; label: string }[] = [
  { id: 'net', label: '手取りを試算' },
  { id: 'trend', label: '5年の推移' },
];

export default function SellerTools({
  predictedPrice,
  municipalityCode,
  municipalityName,
  propertyType,
}: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const [tab, setTab] = useState<Tab>('net');

  return (
    <section>
      <h2 className="section-title">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="font-bold text-primary-text hover:text-primary-dark"
          aria-expanded={open}
          aria-controls="seller-tools"
        >
          売るときの試算 {open ? '−' : '+'}
        </button>
      </h2>

      {open && (
        <div id="seller-tools" className="mt-3">
          <div role="tablist" className="flex gap-5 border-b border-rule">
            {TABS.map((t) => (
              <button
                key={t.id}
                role="tab"
                aria-selected={tab === t.id}
                type="button"
                onClick={() => setTab(t.id)}
                className={`-mb-px border-b-2 pb-2 text-[13px] font-bold transition-colors ${
                  tab === t.id
                    ? 'border-primary text-primary-text'
                    : 'border-transparent text-ink-3 hover:text-ink-2'
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>

          <div className="pt-4">
            {tab === 'net' && <NetProceedsCalc predictedPrice={predictedPrice} />}
            {tab === 'trend' && (
              <TrendChart
                municipalityCode={municipalityCode}
                municipalityName={municipalityName}
                propertyType={propertyType}
              />
            )}
          </div>
        </div>
      )}
    </section>
  );
}
